import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { useTranslation } from 'react-i18next';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import { DashboardFiltersContext } from './filters/DashboardFiltersContext';
import { DashboardFilters } from '../../../models/dashboard';


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

interface MultipleSelectCheckmarksProps {
  ids: string[];
  names: string[];
}

const MultipleSelectCheckmarks = ({ids, names}: MultipleSelectCheckmarksProps) => {
  const { setFilters, unsavedFilters } = React.useContext(DashboardFiltersContext);
  const { t } = useTranslation();
  const [selectedValues, setSelectedValues] = React.useState<string[]>(unsavedFilters.locations);

  const handleChange = (event: SelectChangeEvent<typeof selectedValues>) => {
    const {
      target: { value },
    } = event;

    setSelectedValues(
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  React.useEffect(() => {
    setFilters(
      (prevFilters: DashboardFilters) =>
        ({
          ...prevFilters,
          locations: selectedValues,
        } as DashboardFilters)
    )
  }, [selectedValues, setFilters]);

  React.useEffect(() => {
    setSelectedValues(unsavedFilters.locations);
  }, [unsavedFilters])

  return (
    <div>
      <FormControl sx={{ m: 1, width: 417, marginLeft: '0px'}}>
        <InputLabel id="location">{t('components.filters.location')}</InputLabel>
        <Select
          id="location"
          multiple
          size="small"
          value={selectedValues}
          onChange={handleChange}
          input={<OutlinedInput label={t('components.filters.locations')} />}
          renderValue={(selected) => 
            ids
              .map((id, index) => selected.includes(id) ? index : -1)
              .filter(idIndex => idIndex >= 0)
              .map(idIndex => names[idIndex])
              .join(', ')
          }
          MenuProps={MenuProps}
        >
          {ids.map((id, index) => (
            <MenuItem key={id} value={id}>
              <Checkbox checked={selectedValues.includes(id)} />
              <ListItemText primary={names[index]} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}

export default MultipleSelectCheckmarks;
